import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import SelfAssessment from './selfAssessment'
import displayToastMessage from '../../Common/Alert/displayToastMessage'
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";

function Vendor() {
  const [currentTab, setCurrentTab] = useState("1");
  const [selfRequestsData, setSelfRequestsData] = useState([])
  const { sendRequest: fetchSelfAssessmentList } = useHttp();

  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };

  useEffect(() => {
    getAllInitialData()
  }, []);

  const responseHandler = (result) => {
    if (result.CODE) {
      setSelfRequestsData(result.MSG)
    } else {
      displayToastMessage(
        "Something went wrong, Please try again!",
        "error"
      );
    }
  }

  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
  }

  const getAllInitialData = async () => {
    fetchSelfAssessmentList(APIService.fetchSelfAssessmentList(Number(sessionStorage.getItem("userId"))), responseHandler, errorHandler)
  }

  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="All Self Assessment Requests">
          {selfRequestsData && <SelfAssessment DataAssessment={selfRequestsData} getAllInitialData={getAllInitialData} />}
        </Tab>
      </Tabs>
    </div>
  );
}
export default Vendor;
